import { getLanguage } from '@/utils'

const defaultLang = getLanguage()

/**
 *
 * @param amount
 * @param lang
 * @param options
 * @return {string|*}
 */
const formatCurrency = (amount, lang = defaultLang, options = {}) => {
  if (!amount || !window.Intl) {
    return amount
  }
  return new Intl.NumberFormat(
    lang,
    Object.assign(options, {
      style: 'currency',
    }),
  ).format(amount)
}

export default formatCurrency
